import type {SearchParams, ViewableSearch} from 'src/typings';
import type {AjaxService} from 'core/data-services/ajax.service';
import {ngAsync} from 'shared/utils/ng-@decorators';
import {transferify} from 'shared/utils/data-service-utils';

export class SearchDataService {
    public static serviceName = 'searchDataService';
    public static readonly ROUTE = 'search';

    /*@ngInject*/
    constructor(private ajaxService: AjaxService) {
    }

    @ngAsync()
    public async search<T>(params: SearchParams): Promise<ViewableSearch<SearchParams, T>> {
        return this.ajaxService
            .createRequest(SearchDataService.ROUTE)
            .get(transferify(params));
    }
}